import request from '@/utils/request'
const url = '/admin/generate.generate_tables'
const api = {
  generate(data) {
    return request({
      url: `${url}/generate`,
      method: 'post',
      data
    })
  },
  Export(data) {
    return request({
      url: `${url}/export`,
      method: 'post',
      data
    })
  },
  Preview(data) {
    return request({
      url: `${url}/preview`,
      method: 'post',
      data
    })
  },
  Detail(data) {
    return request({
      url: `${url}/detail`,
      method: 'post',
      data
    })
  },
  Query(data) {
    return request({
      url: `${url}/list`,
      method: 'post',
      data
    })
  },
  DataBaseList(data) {
    return request({
      url: `/admin/generate.code_generate/dataBaseList`,
      method: 'post',
      data
    })
  },
  GetColumnList(data) {
    return request({
      url: `/admin/generate.code_generate/getColumnList`,
      method: 'post',
      data
    })
  },
  LoadTable(data) {
    return request({
      url: `${url}/LoadTable`,
      method: 'post',
      data
    })
  },
  ConfirmUpdateData(data) {
    return request({
      url: `${url}/update`,
      method: 'post',
      data
    })
  },
  Delete(data) {
    return request({
      url: `${url}/destroy`,
      method: 'post',
      data
    })
  }
}

export default api
